import * as errorTypes from 'config/errorTypes';

const GENERAL_ERROR = (r = {}) => r.httpStatus !== 200;

export const UPDATE_ACHIEVEMENT_LEVEL_ERROR = {
    [errorTypes.UPDATE_ACHIEVEMENT_LEVEL_FAILED]: GENERAL_ERROR
};

export const UPDATE_ACHIEVEMENT_SETTING_ERROR = {
    [errorTypes.UPDATE_ACHIEVEMENT_LEVEL_FAILED]: GENERAL_ERROR
};
